export default __webpack_public_path__ + "static/364086_1_0-4757d05591be36114a69ef5088acd85f.woff";